import React, { Component } from "react";

import BotaoForm from './botao_paraForm';
import Modal from 'react-modal';
import axios from 'axios';
import { Redirect, Link } from 'react-router-dom'
import paginate from 'paginate-array';
import Cookies from 'universal-cookie';
import { Spinner } from 'reactstrap';
import { connect } from 'react-redux';

import { FaSistrix } from 'react-icons/fa';
import { MdNavigateBefore, MdLastPage, MdNavigateNext, MdFirstPage } from 'react-icons/md';
import { GoPencil, GoTrashcan } from "react-icons/go";

class TabelaUser extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: [],
            userFiltrados: [],
            pesquisa: '',
            tipoPesquisa: '',
            size: 7,
            page: 1,
            currPage: null,
            tipoErro: [],
            mensagemModal: 'Ops! Temos problemas:',
            redirect: false,
            UserName: '',
            senha: '',
            loading: false,
            erro: false,
            delete: false,
            refresh: false,
            Roles: { value: '', label: '' }
        }
        this.requisicaoListagem = this.requisicaoListagem.bind(this);
        this.mostraAtualizacao = this.mostraAtualizacao.bind(this);
        this.atribuiTipoPesquisa = this.atribuiTipoPesquisa.bind(this);
        this.atribuiPesquisa = this.atribuiPesquisa.bind(this);
        this.limpaPesquisa = this.limpaPesquisa.bind(this);
        this.filtro = this.filtro.bind(this);
        this.firstPage = this.firstPage.bind(this);
        this.lastPage = this.lastPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.buttonPaginacao = this.buttonPaginacao.bind(this);

        this.requisicaoRefresh = this.requisicaoRefresh.bind(this);

        this.requisicaoConsulta = this.requisicaoConsulta.bind(this);
        this.requisicaoDelete = this.requisicaoDelete.bind(this);
        this.requisicaoAtualizacao = this.requisicaoAtualizacao.bind(this);

        this.ModalDelete = this.ModalDelete.bind(this);
        this.ModalLoading = this.ModalLoading.bind(this);
        this.ModalErro = this.ModalErro.bind(this);
        this.ModalRefresh = this.ModalRefresh.bind(this);
    }

    ModalLoading() {
        this.setState({ loading: !this.state.loading })
    }

    ModalDelete(IDUsuario) {
        this.setState({ IDUsuario, delete: !this.state.delete });
    }

    ModalErro() {
        this.setState({ erro: !this.state.erro })
    }

    ModalRefresh() {
        this.setState({ refresh: !this.state.refresh })
    }

    requisicaoDelete() {
        this.setState({ loading: true })
        let cookie = new Cookies();
        let token = cookie.get('token');

        axios.delete(process.env.REACT_APP_URL_REQUISICOES + 'usuarios/' + this.state.IDUsuario,
            {

                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then(res => {
                this.setState({ delete: false, loading: false });
            });
        this.requisicaoAtualizacao();
    }

    requisicaoAtualizacao() {
        let user = this.state.user;
        let IDUsuario = this.state.IDUsuario;

        let posicao = user.findIndex(usuario => usuario.IDUsuario === IDUsuario);
        user.splice(posicao, 1);

        let { page, size } = this.state;

        let currPage = paginate(user, page, size);

        if (currPage.totalPages < page) {
            page = currPage.totalPages;
            currPage = paginate(user, page, size);
        }

        this.setState({
            user,
            page,
            currPage,
            userFiltrados: user
        });
    }

    componentDidMount() {
        // Faz com que volte ao inicio da página
        window.scrollTo(0, 0);

        if (this.props.empresaSelecionada === '') {
            this.setState({ tipoErro: "Selecione uma empresa", mensagemModal: 'Atenção!' })
            this.ModalErro();
        }
        else {
            // Inicia a listagem  de colaboradores cadastradas
            this.requisicaoListagem();
        }
    }

    requisicaoConsulta(IDUsuario) {
        this.setState({
            loading: true
        });
        let cookie = new Cookies();
        let token = cookie.get('token');
        let usuarios;

        axios.get(process.env.REACT_APP_URL_REQUISICOES + 'usuarios/' + IDUsuario,
            {

                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then(res => {
                usuarios = res.data;
                this.setState({
                    IDUsuario: IDUsuario,
                    UserName: usuarios.UserName,
                    Roles: { value: usuarios.Role, label: usuarios.Role },
                    redirect: true,
                    loading: false
                })
            })
            .catch((error) => {
                if (error.response !== undefined || error.response === '') {
                    switch (error.response.status) {
                        case 400:
                            this.setState({
                                tipoErro: error.response.data,
                                loading: false
                            });
                            this.ModalErro();
                            break;

                        case 401:
                            this.requisicaoRefresh();
                            break;

                        case 403:
                            this.setState({
                                tipoErro: "Ação não autorizada",
                                loading: false
                            });
                            this.ModalErro();
                            break;

                        case 408:
                            this.setState({
                                tipoErro: 'Não foi possível conectar ao servidor',
                                loading: false
                            });
                            this.ModalErro();
                            break;

                        default:
                            this.setState({
                                tipoErro: "Erro não identificado. Contate o administrador!",
                                loading: false
                            });
                            this.ModalRefresh();
                            break;
                    }
                }
                else {
                    this.setState({
                        tipoErro: "Erro não identificado. Contate o administrador!",
                        loading: false
                    });
                    this.ModalRefresh();
                }
            })
    }

    requisicaoListagem() {
        this.setState({
            loading: true
        });
        let cookie = new Cookies();
        let token = cookie.get('token');

        axios.get(process.env.REACT_APP_URL_REQUISICOES + 'usuarios',
            {

                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then(res => {
                const user = res.data;
                let { page, size } = this.state;

                const currPage = paginate(user, page, size);

                this.setState({
                    user,
                    currPage,
                    userFiltrados: user,
                    loading: false
                });
            })
            .catch((error) => {
                if (error.response !== undefined || error.response === '') {
                    switch (error.response.status) {
                        case 400:
                            this.setState({
                                tipoErro: error.response.data,
                                loading: false
                            });
                            this.ModalErro();
                            break;

                        case 401:
                            this.requisicaoRefresh();
                            break;

                        case 403:
                            this.setState({
                                tipoErro: "Ação não autorizada",
                                loading: false
                            });
                            this.ModalErro();
                            break;

                        case 408:
                            this.setState({
                                tipoErro: 'Não foi possível conectar ao servidor',
                                loading: false
                            });
                            this.ModalErro();
                            break;

                        default:
                            this.setState({
                                tipoErro: "Erro não identificado. Contate o administrador!",
                                loading: false
                            });
                            this.ModalRefresh();
                            break;
                    }
                }
                else {
                    this.setState({
                        tipoErro: "Erro não identificado. Contate o administrador!",
                        loading: false
                    });
                    this.ModalRefresh();
                }
            })
    }

    requisicaoRefresh() {
        let cookie = new Cookies();
        let token = cookie.get('token')
        let refreshToken = cookie.get('refreshToken')

        axios.post(process.env.REACT_APP_URL_REQUISICOES + 'auth/refresh',
            {
                refreshToken: refreshToken
            },
            {

                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then(res => {
                if (res.status === 200) {
                    const cookies = new Cookies();

                    cookies.set('token', res.data.token, { path: '/' });
                    cookies.set('refreshToken', res.data.refreshToken, { path: '/' });
                    this.requisicaoListagem();
                }
            })
            .catch((error) => {
                if (error.response !== undefined || error.response === '') {
                    switch (error.response.status) {
                        case 400:
                            this.setState({
                                tipoErro: error.response.data,
                                loading: false
                            });
                            this.ModalRefresh();
                            break;

                        case 401:
                            this.setState({
                                tipoErro: 'Sessão Inválida',
                                loading: false
                            });
                            this.ModalRefresh();
                            break;

                        case 403:
                            this.setState({
                                tipoErro: "Ação não autorizada",
                                loading: false
                            });
                            this.ModalRefresh();
                            break;

                        default:
                            this.setState({
                                tipoErro: "Erro não identificado. Contate o administrador!",
                                loading: false
                            });
                            this.ModalRefresh();
                            break;
                    }
                }
                else {
                    this.setState({
                        tipoErro: "Erro não identificado. Contate o administrador!",
                        loading: false
                    });
                    this.ModalRefresh();
                }
            })
    }

    atribuiTipoPesquisa(event) {
        // Atribui o tipo de pesquisa que será usada no filtro
        let tipoPesquisa = event.target.value;
        this.setState({ tipoPesquisa, pesquisa: '' });
    }

    atribuiPesquisa(event) {
        // Atribui a pesquisa que será usada no filtro
        let pesquisa = event.target.value;
        this.setState({ pesquisa });
    }

    filtro(event) {
        //Faz a filtragem em sí
        event.preventDefault();
        let { tipoPesquisa } = this.state;
        let { pesquisa } = this.state;
        let userFiltrados = [];

        if (tipoPesquisa === "User") {
            if (pesquisa !== '') {
                userFiltrados = this.state.user.filter(user => {
                    return user.UserName.toLowerCase().includes(pesquisa.toLowerCase());
                });
            }
            else {
                userFiltrados = this.state.user;
            }
        }
        else if (tipoPesquisa === "codRoles") {
            userFiltrados = this.state.user.filter(user => {
                return user.Role.toLowerCase().includes(pesquisa.toLowerCase());
            });
        }
        else {
            userFiltrados = this.state.user;
        }

        this.setState({ userFiltrados });
        this.mostraAtualizacao(userFiltrados);
    }

    mostraAtualizacao(userFiltrados) {
        //Atualiza as user que aparecem após a filtragem
        const size = this.state.size;

        const currPage = paginate(userFiltrados, 1, size);

        this.setState({ currPage, page: 1 });
    }

    limpaPesquisa() {
        this.setState({ pesquisa: '' });
    }

    firstPage() {
        //Determina a próxima página
        const { size, userFiltrados } = this.state;

        const newPage = 1;
        const newCurrPage = paginate(userFiltrados, newPage, size);

        this.setState({
            page: newPage,
            currPage: newCurrPage
        });
    }

    lastPage() {
        //Determina a página anterior
        const { size, userFiltrados } = this.state;

        if (this.state.currPage !== null) {
            const newPage = this.state.currPage.totalPages > 0 ? this.state.currPage.totalPages : 1;
            const newCurrPage = paginate(userFiltrados, newPage, size);
            this.setState({
                page: newPage,
                currPage: newCurrPage
            });
        }
    }

    previousPage() {
        const { page, size, userFiltrados } = this.state;

        if (page > 1) {
            const newPage = page - 1;
            const newCurrPage = paginate(userFiltrados, newPage, size);

            this.setState({
                page: newPage,
                currPage: newCurrPage
            });
        }
    }

    nextPage() {
        const { currPage, page, size, userFiltrados } = this.state;

        if (this.state.currPage !== null) {
            if (page < currPage.totalPages) {
                let newPage = page + 1;
                let newCurrPage = paginate(userFiltrados, newPage, size);
                this.setState({
                    page: newPage,
                    currPage: newCurrPage
                });
            }
        }
    }

    buttonPaginacao(currPage) {
        if (currPage !== null) {
            if (currPage.totalPages === 1 || currPage.totalPages === 0) {
                return (
                    <button className="btn btn-outline-primary active">{this.state.page}</button>
                );
            }
            else if (currPage.currentPage === currPage.totalPages) {
                return (
                    <div className="btn-group">
                        <button className="btn btn-outline-primary" onClick={this.previousPage}>{this.state.page - 1}</button>
                        <button className="btn btn-outline-primary active">{this.state.page}</button>
                    </div>
                );
            }
            else if (this.state.page - 1 === 0) {
                return (
                    <div className="btn-group">
                        <button className="btn btn-outline-primary active">{this.state.page}</button>
                        <button className="btn btn-outline-primary" onClick={this.nextPage}>{this.state.page + 1}</button>
                    </div>
                );
            }
            else {
                return (
                    <div className="btn-group">
                        <button className="btn btn-outline-primary" onClick={this.previousPage}>{this.state.page - 1}</button>
                        <button className="btn btn-outline-primary active">{this.state.page}</button>
                        <button className="btn btn-outline-primary" onClick={this.nextPage}>{this.state.page + 1}</button>
                    </div>
                );
            }
        }
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={{
                pathname: '/Home/User/NovoUser/Formulario',
                state: {
                    IDUsuario: this.state.IDUsuario,
                    UserName: this.state.UserName,
                    Roles: this.state.Roles
                }
            }} />
        }
        const { currPage } = this.state;
        return (
            <div className="h-100 margemTop">
                <Modal //Modal de exclusão
                    isOpen={this.state.delete}
                    className="estilizacaoModais col-6 col-md-5"
                    overlayClassName="overlay"
                >
                    <div className="float-center text-center">
                        <label> Certeza que deseja excluir esses dados? </label>
                        <div className="row">
                            <div className="col text-right">
                                <button onClick={this.requisicaoDelete} className="btn btn-outline-primary btn-sm col-9 col-sm-6 col-md-5 col-lg-4 col-xl-4 botaoModal">Sim</button>
                            </div>

                            <div className="col text-left">
                                <button onClick={this.ModalDelete} className="btn btn-outline-danger btn-sm col-9 col-sm-6 col-md-5 col-lg-4 col-xl-4 botaoModal">Não</button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal  //Modal de erro
                    isOpen={this.state.erro}
                    className="estilizacaoModais col-6 col-md-5"
                    overlayClassName="overlay"
                >
                    <div className="float-center text-center modalErro">
                        <label> {this.state.mensagemModal} </label><br />
                        {this.state.tipoErro.length === 1 ? this.state.tipoErro.map((erro, index) =>
                            <p key={index}>{erro}</p>) : <p> {this.state.tipoErro} </p>}
                        <div className="row">
                            <div className="col">
                                <button onClick={this.ModalErro} className="btn btn-outline-primary btn-sm col-9 col-sm-6 col-md-5 col-lg-4 col-xl-4 botaoModal">Ok</button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal  //Modal de Loading
                    isOpen={this.state.loading}
                    className="estilizacaoModais col-6 col-md-5"
                    overlayClassName="overlay"
                >
                    <div className="float-center text-center">
                        <label> Carregando dados... </label><br />
                        <Spinner color="primary" size="lg" />
                    </div>
                </Modal>
                <Modal  //Modal de refresh
                    isOpen={this.state.refresh}
                    className="estilizacaoModais col-6 col-md-5"
                    overlayClassName="overlay"
                >
                    <div className="float-center text-center modalErro">
                        <label> Ops! Temos problemas: </label><br />
                        {this.state.tipoErro.length === 1 ? this.state.tipoErro.map((erro, index) =>
                            <p key={index}>{erro}</p>) : <p> {this.state.tipoErro} </p>}
                        <div className="row">
                            <div className="col">
                                <Link to='/'><button onClick={this.ModalRefresh} className="btn btn-outline-primary btn-sm col-9 col-sm-6 col-md-5 col-lg-4 col-xl-4 botaoModal">Ok</button></Link>
                            </div>
                        </div>
                    </div>
                </Modal>
                <nav className="margemBottom">
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-11 col-md-9 col-lg-10 col-xl-8">
                            <div className="row">
                                <div className="col">
                                    <span className="navbar-brand"><label> Usuários </label></span>
                                </div>
                                <form>
                                    <div className="row">
                                        <div className="col-4 col-sm-5 col-md-4 col-lg-4">
                                            <select
                                                className="form-control input-group-prepend"
                                                type="select"
                                                name="tipopesquisa"
                                                required
                                                onChange={this.atribuiTipoPesquisa}>
                                                <option defaultValue> Selecione </option>
                                                <option value="User" className="input-group-text"> Usuário </option>
                                                <option value="codRoles" className="input-group-text"> Permissão </option>
                                            </select>
                                        </div>
                                        <div className="col-8 col-sm-7 col-md-8 col-lg-8 tiraPadding">
                                            <div className="input-group-prepend">
                                                <div className="input-group">
                                                    <input id="filtro"
                                                        placeholder="Pesquisar"
                                                        type="text"
                                                        value={this.state.pesquisa}
                                                        className="form-control col-10"
                                                        onChange={this.atribuiPesquisa}
                                                        autoComplete="off" />
                                                    <button type="submit" className="input-group-text" onClick={this.filtro}><FaSistrix /></button>
                                                </div>
                                                <div className="col text-right tiraPadding">
                                                    <BotaoForm />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </nav>

                <div className="row justify-content-center h-100 expansaoDiv">
                    <div className="col-12 col-sm-11 col-md-9 col-lg-10 col-xl-8">
                        <div className="table-responsive">
                            <table className="table table-hover table-bordeless table-sm text-center">
                                <thead>
                                    <tr className="table table-primary">
                                        <th className="align-middle">Usuários</th>
                                        <th className="align-middle">Permissão</th>
                                        <th className="align-middle" colSpan="2"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currPage &&
                                        currPage.data.map(user =>
                                            <tr key={user.IDUsuario}>
                                                <td className="align-middle">{user.UserName}</td>
                                                <td className="align-middle">{user.Role}</td>
                                                <td>
                                                    <button className="btn" data-tip="Editar" onClick={() => this.requisicaoConsulta(user.IDUsuario)}><GoPencil size={20} /></button>
                                                </td>
                                                <td className="align-middle">
                                                    <button className="btn" data-tip="Excluir" onClick={() => this.ModalDelete(user.IDUsuario)}><GoTrashcan size={20} /></button>
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>
                        <div className="row justify-content-end right paginacao">
                            <div className="btn-toolbar">
                                <div className="btn-group">
                                    <button className="btn btn-outline-primary" onClick={this.firstPage}><MdFirstPage /></button>
                                    <button className="btn btn-outline-primary" onClick={this.previousPage}><MdNavigateBefore /></button>

                                    {this.buttonPaginacao(currPage)}

                                    <button className="btn btn-outline-primary" onClick={this.nextPage}><MdNavigateNext /></button>
                                    <button className="btn btn-outline-primary" onClick={this.lastPage}><MdLastPage /></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

const mapStateToProp = (state) => ({
    empresaSelecionada: state.dadosEmpresa.empresaSelecionada
});

export default connect(mapStateToProp)(TabelaUser);

